import { ref } from 'vue';

const serverHasCrashed = ref(false);

export default function useServerCrash() {
  return {
    serverHasCrashed,
  };
}
